"use strict"
exports.__esModule = true;
exports.StopwatchIconConfig = {
  name: 'StopwatchIcon',
  height: 512,
  width: 448,
  svgPath: 'M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z',
  yOffset: 0,
  xOffset: 0,
};
exports.StopwatchIcon = require('../createIcon').createIcon(exports.StopwatchIconConfig);
exports["default"] = exports.StopwatchIcon;